import useAppStore from "@/context/store";
import { getOrgIdByUser } from "@/utils/gaoding";
import { ORG_CONTACT_SOURCE } from "@/utils/gd-org";
import { Dropdown } from "antd";
import classNames from "classnames";
import { useMemo, useState } from "react";
import GdOrgList, { getOrgTypeText } from "../GdOrgList";
import HBIcon from "../HBIcon";
import { TrackerDiv } from "../Tracker";
import styles from "./index.module.less";

interface OrgSwitchProps {
  isCollapsed?: boolean;
}

export default function OrgSwitch({ isCollapsed = false }: OrgSwitchProps) {
  const user = useAppStore((s) => s.user);
  const [visible, setVisible] = useState(false);
  const orgList = useAppStore((s) => s.orgList);

  const currentOrgId = getOrgIdByUser(user);
  const currentOrg = useMemo(() => {
    if (orgList) {
      return orgList?.find((org) => org.org_id === currentOrgId);
    }
  }, [orgList, currentOrgId]);

  const dropdownContent = (
    <TrackerDiv
      className={styles.dropdownContent}
      data-gd-expose="dialog_expose"
      data-dialog-title="企业切换弹窗"
      data-module-name="企业切换弹窗"
      data-subject-name="弹窗"
      data-content-source="顶部导航栏"
    >
      <GdOrgList
        dataSource={orgList || []}
        value={currentOrg}
        autoSwitchOnClick={true}
        showCreateButton={true}
        contactSource={ORG_CONTACT_SOURCE.HB_SWITCH_ORGANIZATION_CREATE}
      />
    </TrackerDiv>
  );

  if (!currentOrg) {
    return null;
  }

  return (
    <Dropdown
      overlay={dropdownContent}
      trigger={["click"]}
      placement="bottomLeft"
      onVisibleChange={setVisible}
      getPopupContainer={() =>
        document.getElementById("layout-header") as HTMLElement
      }
      overlayClassName={styles.dropdown}
    >
      <div
        className={classNames(styles.orgSwitch, {
          [styles.collapsed]: isCollapsed,
        })}
      >
        <div className={styles.content}>
          <div className={styles.title}>{currentOrg?.company?.name}</div>
          <div className={styles.description}>{getOrgTypeText(currentOrg)}</div>
        </div>
        <div className={`${styles.arrow} ${visible ? styles.active : ""}`}>
          <HBIcon type="a-Polygon7" />
        </div>
      </div>
    </Dropdown>
  );
}
